import { RichText, Text } from '@sitecore-jss/sitecore-jss-nextjs';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { StyledDivider, StTextContainer } from '../CommonSubscribe.styles';
import { StDTPGridContainer } from '../../shared/Container/Container.styles';
import { CommonSubscribeProps } from '../CommonSubscribe.types';
import { useEffect } from 'react';

const CommonResubscribe = (props: CommonSubscribeProps): JSX.Element => {
  const theme = useTheme();
  useEffect(() => {
    const pageContainerElement = props.pageContainerRef?.current;
    if (pageContainerElement) {
      pageContainerElement.style.minHeight = 'calc(100vh - 380px)';
    }
    const style = document.createElement('style');
    style.innerHTML =
      '@media(min-width: 960px) and (max-width: 1112.98px){.container{min-height: calc(100vh - 22rem)!important;}} @media(min-width: 1113px){.container{min-height:calc(100vh - 15rem);}}';
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, [props.pageContainerRef]);
  if (!props?.fields) return <></>;
  const { heading, content } = props?.fields;

  return (
    <StDTPGridContainer id="common-resubscribe" className="ui-common-resubscribe">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        rowGap="2rem"
        sx={{ marginBlock: '2rem' }}
      >
        <Typography
          variant="h1"
          data-testid="title"
          textAlign="center"
          sx={{
            display: 'flex',
            color: theme.palette.themeColor.main,
            fontSize: '2rem',
            fontStyle: 'normal',
            fontWeight: '600',
            lineHeight: '2.5rem',
            [theme.breakpoints.down('md')]: {
              fontSize: '2rem',
            },
          }}
        >
          <Text field={heading} />
        </Typography>
        <StyledDivider />
        <StTextContainer>
          <Box
            data-testid="content"
            textAlign="center"
            sx={{
              color: (theme: any) => theme.palette.themeColor.main,
              fontSize: '1.5rem',
              fontStyle: 'normal',
              fontWeight: '600',
              lineHeight: '2rem',
            }}
          >
            <RichText field={content} />
          </Box>
        </StTextContainer>
      </Box>
    </StDTPGridContainer>
  );
};

export default CommonResubscribe;
